import React, {
  forwardRef,
  HTMLAttributes,
  Ref,
  PropsWithChildren,
} from "react";

import { ListItem } from "./ListItem";
import { ListSeparator } from "./ListSeparator";
import { StyledList } from "./Styles";

export interface ListProps {
  /** Applies passed classes */
  className?: string;
}

export const _List = forwardRef(
  (
    {
      children,
      className,
      ...props
    }: PropsWithChildren<ListProps> & HTMLAttributes<HTMLUListElement>,
    ref: Ref<HTMLUListElement> | null | undefined
  ) => {
    return (
      <StyledList className={className} ref={ref} tabIndex={-1} {...props}>
        {children}
      </StyledList>
    );
  }
);

_List.displayName = "List";

// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757
export const List = Object.assign({}, _List, {
  Item: ListItem,
  Separator: ListSeparator,
});
